<template>
  <!-- 保单号 -->
  <div class="detailsNumber">
    <!-- 头部 -->
    <div class="numberTh">
      <span class="baodanId">保单编号: {{ rowOrder.insuranceCode }}</span>
      <div class="NoPay">
        <el-button
          class="button14"
          style="width: 118px"
          type="primary"
          @click="printPay(rowOrder)"
          v-if="rowOrder.insuranceStatus"
          >{{
            rowOrder.insuranceStatus == 2
              ? "下载付款通知书"
              : rowOrder.insuranceStatus == 4
              ? "下载电子保单"
              : ""
          }}</el-button
        >
      </div>
    </div>
    <!-- 分割线 -->
    <el-divider></el-divider>

    <!--订单 信息 -->
    <table class="tableALL">
      <tr class="rowCLasspad">
        <td>
          <span> 保单状态:</span>
          <span class="font600" :class="orderClolor[rowOrder.insuranceStatus]">
            {{ setOrderS[rowOrder.insuranceStatus] }}</span
          >
        </td>
        <td>
          <span>投保险种:</span>
          <span class="font400">
            {{ rowOrder.insuranceName ? rowOrder.insuranceName : "--" }}</span
          >
        </td>
        <td>
          <span> 承保机构:</span>
          <span class="font400">
            {{ rowOrder.companyName ? rowOrder.companyName : "--" }}</span
          >
        </td>
      </tr>
      <tr class="rowCLasspad">
        <td>
          <span> 保险年份:</span>
          <span class="font400">
            {{
              rowOrder.occurrenceYear ? rowOrder.occurrenceYear : "--"
            }}年</span
          >
        </td>
        <td>
          <span> 保险开始日期:</span>
          <span class="font400">
            {{ rowOrder.startTime | formatDate("yyyy-MM-dd") }}</span
          >
        </td>
        <td>
          <span> 保险结束日期:</span>
          <span class="font400">
            {{ rowOrder.endTime | formatDate("yyyy-MM-dd") }}</span
          >
        </td>
      </tr>
      <tr class="rowCLasspad">
        <td>
          <span> 投保品种:</span>
          <span class="font400">
            {{ rowOrder.itemName ? rowOrder.itemName : "--" }}</span
          >
        </td>
        <td>
          <span> 第一被保险人:</span>
          <span class="font400">
            {{ rowOrder.applicantName ? rowOrder.applicantName : "--" }}</span
          >
        </td>
        <td>
          <span> 第二被保险人:</span>
          <span class="font400">
            {{ rowOrder.insuredName ? rowOrder.insuredName : "--" }}</span
          >
        </td>
      </tr>
      <tr class="rowCLasspad">
        <td>
          <span>总保费:</span>
          <span class="font400">
            {{ rowOrder.insuranceFee ? rowOrder.insuranceFee : "--" }} 元</span
          >
        </td>
        <td>
          <span>总保额:</span>
          <span class="font400">
            {{ rowOrder.insuranceAmt ? rowOrder.insuranceAmt : "--" }} 元</span
          >
        </td>
        <td v-if="rowOrder.insuranceStatus == 3">
          <span> 状态更新时间:</span>
          <span class="font400">
            {{ rowOrder.endTime | formatDate("yyyy-MM-dd hh:mm:ss") }}</span
          >
        </td>
        <td v-else></td>
      </tr>
    </table>
    <!-- 分割线 -->
    <el-divider></el-divider>
  </div>
</template>

<script>
export default {
  name: "OrderCar",
  props: {
    rowOrder: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      setOrderS: ["", "", "待缴费", "", "生效中"],
      orderClolor: ["", "", "", "", "greenC"],
    };
  },
  computed: {},
  methods: {
    // 获取付款通知书 打印 链接
    printPay(row) {
      if (row.insuranceStatus === 2) {
        window.open(row.planNoticeUrl);
      } else if (row.insuranceStatus === 4) {
        window.open(row.elecPolicyUrl);
      }
      // console.log("打印付款通知书--- 获取到打印的文件");
      // const { respCode, obj } = await getofflinePayment({
      //   id: this.rowOrder.id,
      // });
      // if (respCode === 0) {
      //   window.open(obj);
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-divider--horizontal {
  background-color: #e5e5e5 !important;
}
.detailsNumber {
  width: 1140px;
  height: 280px;
  margin: 0 auto;
}
.numberTh {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
}

.el-divider--horizontal {
  background-color: #f5ebdf;
  margin: 20px 0;
}
.baodanId {
  font-size: 20px;
  color: $--color-primary;
}

.font600 {
  font-size: 20px;
  font-weight: 600;
  margin-left: 10px;
  color: #ff831e;
}

.font400 {
  font-size: 16px;
  font-weight: 400;
  margin-left: 10px;
  color: #303133;
}
.el-button {
  width: 92px;
  height: 40px;
  padding: 0;
}
.tableALL {
  width: 100%;
  // background-color: yellow;
}
.rowCLasspad {
  line-height: 50px;
  color: #303133;
  display: flex;
  td {
    flex: 1;
  }
}
.flex2Dis {
  flex: 2 !important;
}
.paddingLeft {
  padding-left: 20px;
}
.statusColor {
  color: #ff831e;
}
.colorHui {
  color: #666666;
}
.greenC {
  color: #11d8a0;
  // background-color: #d9fff0;
}
</style>
